'use client';

import { AnimationContainer } from '@/components/ui/animation-container';
import { MagicBadge } from '@/components/ui/magic-badge';
import {
  StepUploadAnimation,
  StepOCRAnimation,
  StepTranslateAnimation,
  StepExportAnimation,
  StickyStepsSection,
} from '@/components/ui/step-animations';
import { Upload, Eye, Edit3, Download } from 'lucide-react';
import { TranslationKeys } from '../types';

export default function HowItWorksSection({ t }: { t: TranslationKeys }) {
  return (
    <section id="how-it-works" className="pt-6 pb-20 px-4">
      <div className="max-w-7xl mx-auto">
        <AnimationContainer delay={0.1}>
          <div className="flex flex-col items-center justify-center w-full py-4 max-w-xl mx-auto mb-10">
            <MagicBadge title={t.howItWorks} />
            <h2 className="text-center text-3xl md:text-5xl !leading-[1.1] font-bold text-gray-900 mt-6">
              {t.processTitle}
            </h2>
            <p className="mt-4 text-center text-lg text-gray-600 max-w-lg">
              {t.processDesc}
            </p>
          </div>
        </AnimationContainer>

        <StickyStepsSection
          steps={[
            {
              number: '01',
              title: t.step1,
              description: t.step1Desc,
              icon: <Upload className="w-5 h-5" />,
              animation: <StepUploadAnimation t={t} />,
            },
            {
              number: '02',
              title: t.step2,
              description: t.step2Desc,
              icon: <Eye className="w-5 h-5" />,
              animation: <StepOCRAnimation t={t} />,
            },
            {
              number: '03',
              title: t.step3,
              description: t.step3Desc,
              icon: <Edit3 className="w-5 h-5" />,
              animation: <StepTranslateAnimation t={t} />,
            },
            {
              number: '04',
              title: t.step4,
              description: t.step4Desc,
              icon: <Download className="w-5 h-5" />,
              animation: <StepExportAnimation t={t} />,
            },
          ]}
        />
      </div>
    </section>
  );
}
